<template>
<div>

  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

</div>

</template>

<script>

import { mapGetters } from 'vuex';
import axios          from 'axios'
import alertBox       from '@/components/common/AlertBox.vue'

  export default {
  props : ['url','data','giftTicket'],

     components: {alertBox},
    data () {
      return {
        
          msg      : {title : '',body:'',type :0},
          xml      : ''
                          
      }
    },

    
    computed: {
     ...mapGetters(['company']),
      
    },
    
    
    methods: 
    {
     
     checkStatus()
     {
        let xml = '<Service><cmd>=K</cmd></Service>'
     },
     
     clickHandler() 
     {

        //console.log(this.data.data[0]) 

        let xml = '' 
        if(this.giftTicket==true) 
        {
          xml = '<Service>'

          xml += '<cmd>=o</cmd>'
          xml += '<cmd>="/()</cmd>'
          xml += '<cmd>="/(             SCONTRINO DI CORTESIA)</cmd>'
          xml += '<cmd>="/()</cmd>'
          xml += '<cmd>="/$4/ (' + "S" + this.data.saleId + ') </cmd>' 
          xml += '<cmd>="/()</cmd>'
          xml += '<cmd>=o</cmd>'
          xml += '</Service>'
          
        }
        else
        {
        
        let lotteryID = ''
        if(this.data.lottery)
        {  
          lotteryID = "<cmd>=/?L/$1/" + this.data.lottery + "</cmd>"
        }
        
        let discount = this.data.data[0][0].total_discount
        
        xml  = '<Service>'
        xml += lotteryID

        this.data.data[0].forEach(item =>
        {
          xml += '<cmd>=R1/$'+ item.price + '/ (' + item.barcode + ' ' + item.category + ')</cmd>'    
          if(item.discount>0)
          {
            xml += '<cmd>=V/$' + item.discount_value + '</cmd>'      
          }
        })
        

        
        if(discount != '0.00')
        {
          xml += '<cmd>=S</cmd>'    
          xml += '<cmd>=V/$' + discount + '</cmd>'    
          
        }  
    
        this.data.data[1].forEach(item=>{
          if(item.typeId == 'CASH')
          {  
            xml += '<cmd>=T1/$' + item.total + '</cmd>'    
          }
          
          if(item.typeId == 'ELEC')
          {  
            xml += '<cmd>=T3/$' + item.total + '</cmd>'    
          }
    
          if(item.typeId == 'CRED')
          {  
            xml += '<cmd>=T2/$' + item.total + '</cmd>'    
          }
    
        })
    
        

        xml += '<cmd>=c</cmd>'

        xml += '<cmd>=o</cmd>'
        xml += '<cmd>="/()</cmd>'
        xml += '<cmd>="/(             SCONTRINO DI CORTESIA)</cmd>'
        xml += '<cmd>="/()</cmd>'
        xml += '<cmd>="/$4/ (' + "S" + this.data.saleId + ') </cmd>' 
        xml += '<cmd>="/()</cmd>'
        xml += '<cmd>=c</cmd>'
        xml += '</Service>'

        }

        
        this.xml = xml
        console.log(this.xml)
          axios({
               
                url    : this.url + '/service.cgi',
                method : 'post',
                data   : xml

                

              }).then(res => {
                
                 this.$emit('finish')

                console.log('RT Response',res)

              }).catch(err => {

                this.$emit('finish')  
                console.log('Errore RT',err)  
              })
        
        
        
   
     } 
      

    }
  }
</script>
<style scoped>





 
  h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}

</style>
